import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {ClientsService} from "../../models/clients/clients.service";
import {GlobLiveSearchComponent} from './component';

@NgModule({
    declarations: [
        GlobLiveSearchComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        GlobLiveSearchComponent
    ],
    providers: [
        ClientsService
    ]
})

export class GlobLiveSearchModule {
}



// WEBPACK FOOTER //
// ./src/app/components/glob-search/module.ts